import { config } from '@plandi/common'

const mainPageUrl = config.isDev
  ? 'https://dev.plandi.io/shop'
  : config.isStage
  ? 'https://stage.plandi.io/shop'
  : 'https://plandi.io/shop'

export const URLS = {
  main: mainPageUrl,
  home: '/projects',
  projects: {
    create: '/projects/create',
    me: '/projects/me',
    list: '/projects',
    edit: '/projects/[slugName]/[projectId]/edit',
    detail: '/projects/[slugName]/[projectId]',
    favorites: '/projects/favorites',
    user: '/projects/users/[userId]',
    profile: '/projects/profile/[userId]',
    chats: {
      detail: '/projects/[slugName]/[projectId]/chats/[chatId]',
      project: '/projects/[slugName]/[projectId]/chats',
      me: '/projects/chats/me'
    }
  },
  goods: {
    create: '/goods/create',
    me: '/goods/me',
    list: '/goods',
    edit: '/goods/[slugName]/[productId]/edit',
    detail: '/goods/[slugName]/[productId]',
    favorites: '/goods/favorites',
    user: '/goods/users/[userId]',
    profile: '/goods/profile/[userId]',
    chats: {
      detail: '/goods/[slugName]/[productId]/chats/[chatId]',
      product: '/goods/[slugName]/[productId]/chats',
      me: '/goods/chats/me'
    }
  },
  favorites: '/favorites',
  models: {
    list: '/models',
    me: '/models/me',
    user: '/models/users/[userId]',
    profile: '/models/profile/[userId]',
    create: '/models/create',
    edit: '/models/[slugName]/[modelId]/edit',
    detail: '/models/[slugName]/[modelId]',
    statistics: '/models/[slugName]/[modelId]/statistics',
    chats: {
      detail: '/models/[slugName]/[modelId]/chats/[chatId]',
      project: '/models/[slugName]/[modelId]/chats',
      me: '/models/chats/me'
    }
  },
  notifications: {
    settings: '/notifications-settings'
  },
  subscriptions: '/subscriptions'
} as const
